import type { InputHTMLAttributes } from "react";

interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  mono?: boolean;
}

export function TextInput({
  mono = false,
  className = "",
  type = "text",
  ...props
}: TextInputProps) {
  return (
    <input
      type={type}
      className={`h-10 rounded-lg border border-muted bg-surface px-3 text-foreground focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/20 ${mono ? "font-mono text-xs" : "text-sm"} ${className}`}
      {...props}
    />
  );
}
